import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BouncebanChipProps as Props } from './types';
import { Avatar, Typography } from '@mui/material';

export const BouncebanChip = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BouncebanChip', className)}
      sx={SX.root}
      avatar={
        <Avatar size={12} src="/assets/images/bounce-ban.svg" alt="bounceban" />
      }
      color="default"
      variant="soft"
      size="xsmall"
      label={
        <Typography variant="body5" color="grey.600" fontWeight={400}>
          Powered by{' '}
          <Typography
            variant="body5"
            color="grey.600"
            fontWeight={700}
            component="span"
          >
            BounceBan
          </Typography>
        </Typography>
      }
    />
  );
});

BouncebanChip.displayName = 'BouncebanChip';
